/* Gemonier: complementos de producto, independientes del BOGO.
 * Usa la misma API/eventos nativos del carrito del tema original.
 */
(function () {
  if (window.__gemonierProductOfferLoaded) return;
  window.__gemonierProductOfferLoaded = true;
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-gm-pdp-set] [data-gm-pdp-variants]');
    if (!select) return;
    const item = select.closest('[data-gm-pdp-item]');
    const choice = select.selectedOptions[0];
    const price = item && item.querySelector('[data-gm-pdp-price]');
    const compare = item && item.querySelector('[data-gm-pdp-compare]');
    if (price && choice) price.textContent = choice.dataset.price || '';
    if (compare && choice) {
      compare.textContent = choice.dataset.compare || '';
      compare.hidden = !choice.dataset.compare;
    }
    const image = item && item.querySelector('.gm-pdp-set__image img');
    if (image && choice && choice.dataset.imageSrc) {
      image.srcset = choice.dataset.imageSrcset || '';
      image.src = choice.dataset.imageSrc;
      image.alt = choice.dataset.imageAlt || '';
      if (choice.dataset.imageWidth) image.width = Number(choice.dataset.imageWidth);
      if (choice.dataset.imageHeight) image.height = Number(choice.dataset.imageHeight);
    }
  });
  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-gm-pdp-set] [data-gm-pdp-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    const area = btn.closest('[data-gm-pdp-set]');
    const item = btn.closest('[data-gm-pdp-item]');
    const chosen = item.querySelector('[data-gm-pdp-variants]');
    const variantId = chosen ? chosen.value : item.querySelector('[data-gm-pdp-variant-id]')?.value;
    const status = area.querySelector('[data-gm-pdp-status]');
    if (!variantId || !/^\d+$/.test(String(variantId))) return;
    const previous = btn.innerHTML;
    btn.disabled = true;
    btn.setAttribute('aria-busy','true');
    btn.textContent = '…';
    if (status) { status.textContent='Añadiendo al carrito…'; status.removeAttribute('data-error'); }
    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles:true, detail:{ sections: sectionsToBundle } }));
      const data = new FormData();
      data.append('id', variantId);
      data.append('quantity', '1');
      data.append('sections', Array.from(new Set(sectionsToBundle)).join(','));
      data.append('sections_url', root + 'variants/' + variantId);
      const response = await fetch(root+'cart/add.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body:data });
      const added = await response.json();
      if (!response.ok) throw new Error(added.description || 'No se ha podido añadir.');
      if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
        window.location.assign(root+'cart');
        return;
      }
      const cartResponse = await fetch(root+'cart.js', { headers:{Accept:'application/json'} });
      if (!cartResponse.ok) throw new Error('No se ha podido actualizar el carrito.');
      const cart = await cartResponse.json();
      cart.sections = added.sections || {};
      const drawer = document.querySelector('#cart-drawer');
      // Shopify may omit section HTML on some response errors. Native drawer assumes it is present.
      if (drawer && !cart.sections[drawer.getAttribute('section-id') || 'cart-drawer'] && !Object.values(cart.sections).some(x => typeof x === 'string' && x.includes('cart-drawer__line-items'))) {
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      } else {
        // Keep the customer on the product page while refreshing the cart and badge.
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart:cart}}));
      }
      if (status) status.textContent = '¡Producto añadido al carrito!';
    } catch (e) {
      if (status) {status.textContent=e.message || 'No se ha podido añadir. Inténtalo de nuevo.';status.setAttribute('data-error','');}
    } finally {
      btn.disabled=false;
      btn.removeAttribute('aria-busy');
      btn.innerHTML=previous;
    }
  });
})();
